var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group-append',{class:{
    'correct-answer': _vm.correctAnswerClass,
    'incorrect-answer': _vm.incorrectAnswerClass,
    'unscored-answer': _vm.unscoredAnswerClass,
  },attrs:{"is-text":""}},[_c('div',{staticClass:"answer-status-icon",attrs:{"title":this.answerIcon.title}},[_c('font-awesome-icon',{attrs:{"icon":this.answerIcon.fa}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }